// Counter

document.addEventListener("DOMContentLoaded", function() {
    const countElements = document.querySelectorAll('.count');

    const startCounting = (countElement) => {
        const targetNumber = parseInt(countElement.getAttribute('data-target'), 10);

        // Check if animations are disabled
        if (document.documentElement.classList.contains('wcagbkplugin-disable-animations')) {
            countElement.textContent = targetNumber;
            return; // do not start animation
        }

        let currentNumber = 0;
        const increment = Math.ceil(targetNumber / 100);
        const duration = 2000;
        const intervalTime = duration / (targetNumber / increment);

        const interval = setInterval(() => {
            currentNumber += increment;
            if (currentNumber >= targetNumber) {
                currentNumber = targetNumber;
                clearInterval(interval);
            }
            countElement.textContent = currentNumber;
        }, intervalTime);
    };

    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                startCounting(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, options);

    countElements.forEach(countElement => {
        observer.observe(countElement);
    });
});


// Viewport animation

function handleIntersection(entries, observer) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
        } else {
            entry.target.classList.remove('is-visible');
        }
    });
}

const options = {
    root: null, // Standardwert: viewport
    rootMargin: '0px',
    threshold: 0.1 // 10% des Elements müssen sichtbar sein
};

const observer = new IntersectionObserver(handleIntersection, options);

document.querySelectorAll('.animate').forEach(element => {
    observer.observe(element);
});

// Open "Start a Project" Modal by clicking on a Link
window.addEventListener('load', function () {
    const urlParams = new URLSearchParams(window.location.search);
    const modalId = urlParams.get("modal");
    if (modalId) {
        const trigger = document.querySelector('[data-bs-target="#' + modalId + '"]');
        if (trigger) {
            trigger.click();
        } else {
            console.warn("Kein Button mit data-bs-target='#" + modalId + "' gefunden.");
        }
    }
});

// Language switcher button in navbar
let selectorButton = document.querySelector('.select-language');
if (selectorButton) {
    selectorButton.addEventListener('click', function() {
        document.querySelector('.select-language-content').classList.toggle('show');
    });
}
